/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-trailing-spaces */
/* eslint-disable padded-blocks */
/* eslint-disable indent */

const sectionClick = ($expandable_section, $section_top) => {

    //  Determine the target section to show
    const $section_content = $expandable_section.querySelector('[expandable-section-content]');

    //  Remove expandable-active class from other elements
    const item = $expandable_section.querySelectorAll('.expandable-active');
    if (item.length > 0) {
        for (let i = 0; i < item.length; i += 1) {
            item[i].classList.remove('expandable-active');
        }
        return;
    }

    //  Apply the expandable-active class to tab and target element
    $section_top.classList.add('expandable-active');
    $section_content.classList.add('expandable-active');
};

export const initExpandableSection = () => {

    //  Get each step section on the page
    const expandable_sections = document.querySelectorAll('[expandable-section]');

    for (let i = 0; i < expandable_sections.length; i += 1) {

        //  Define the step section
        const $expandable_section = expandable_sections[i];

        //  Get the tab clickable area
        const $section_top = $expandable_section.querySelector('[expandable-section-top]');

        //  On click of tab selector
        $section_top.addEventListener('click', (e) => {
            e.preventDefault();
            sectionClick($expandable_section, $section_top);
        });
    }
};  
export default 'initExpandableSection';
